// extracted by css-extract-rspack-plugin
export default {"distinction":"_36ff3458","icon":"_9e38d1c1","title":"_a53d82ea","goldDiamond":"_cbed5b4e","platinumDiamond":"_37f4b258","description":"_2f95a9cc"};